"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Close = exports.Description = exports.Title = exports.Content = exports.Trigger = exports.Root = void 0;
var dialog_js_1 = require("./dialog.js");
Object.defineProperty(exports, "Root", { enumerable: true, get: function () { return dialog_js_1.DialogRoot; } });
var dialog_js_2 = require("./dialog.js");
Object.defineProperty(exports, "Trigger", { enumerable: true, get: function () { return dialog_js_2.DialogTrigger; } });
var dialog_js_3 = require("./dialog.js");
Object.defineProperty(exports, "Content", { enumerable: true, get: function () { return dialog_js_3.DialogContent; } });
var dialog_js_4 = require("./dialog.js");
Object.defineProperty(exports, "Title", { enumerable: true, get: function () { return dialog_js_4.DialogTitle; } });
var dialog_js_5 = require("./dialog.js");
Object.defineProperty(exports, "Description", { enumerable: true, get: function () { return dialog_js_5.DialogDescription; } });
var dialog_js_6 = require("./dialog.js");
Object.defineProperty(exports, "Close", { enumerable: true, get: function () { return dialog_js_6.DialogClose; } });
//# sourceMappingURL=dialog.parts.js.map